import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Text} from '@gravity-ui/uikit';
import {AnswersStats as AnswerStatsModel, MatrixStats} from 'common/models/success';
import {isEmpty} from 'lodash';
import i18n from 'ui/i18n';

import AnswersStats from '../AnswersStats';
import QuestionInfo from '../QuestionInfo';

import {QuestionStatsProps} from './QuestionStats.types';
import {isMatrixStats, transformToStats} from './QuestionStats.utils';

import './QuestionStats.scss';

const cnQuestionStats = cn('QuestionStats');

const QuestionStats: FC<QuestionStatsProps> = ({stats}) => {
    if (isEmpty(stats.stats)) {
        return null;
    }

    const isMatrix = isMatrixStats(stats.stats);

    return (
        <QuestionInfo
            label={stats.label}
            info={i18n('success-page', 'answers-count', {count: stats.answers})}
        >
            {isMatrix ? (
                Object.entries(stats.stats as MatrixStats).map(([subtitle, matrixStats], index) => (
                    <div key={index}>
                        <Text className={cnQuestionStats('Subtitle')} variant="body-2" as="div">
                            {subtitle}
                        </Text>
                        <AnswersStats
                            totalCount={stats.answers}
                            stats={transformToStats(matrixStats)}
                        />
                    </div>
                ))
            ) : (
                <AnswersStats totalCount={stats.answers} stats={stats.stats as AnswerStatsModel} />
            )}
        </QuestionInfo>
    );
};
export default QuestionStats;
